import React, { useEffect, useState } from 'react'
import { TextField, Chip, Select, MenuItem, FormControl, InputLabel, } from '@material-ui/core'
import { useSelector } from 'react-redux'
import store, { symbolFilter, addNewSymbol, deleteOptionSymbol } from './store'
import { CssTextField } from './DarkModeTextField'
import DeleteIcon from '@material-ui/icons/Delete';

const types = {
    "eq": "EQ",
    "fut": "FUT"
}

const AddNewSymbol = (props) => {

    useEffect(()=> {
        document.title='Add new symbol'
    }, [])

    const symbols = useSelector((state)=> state.initFunction.symbols);
    const darkMode = useSelector((state) => state.initFunction.darkMode);
    var color = darkMode ? 'white' : 'black'
    const [ symbolKeyLength, setSymbolKeyLength ] = useState(true)    

    const handleAddNew = (e) => {
        e.preventDefault();
        const form = new FormData(e.target);

        for(let i in symbols) {
            console.log('Chk', symbols[i])
            if((symbols[i].sym.toLowerCase() === form.get("symbol").toLowerCase()) && (symbols[i].ty.toLowerCase() === form.get("stockType").toLowerCase())) {
                alert("Symbol already exist")
                return
            }
        }

        store.dispatch(addNewSymbol({ data: { "sym": form.get("symbol").toUpperCase(), ty: form.get("stockType") } }))
        setSymbolKeyLength(!symbolKeyLength)
    }

    const handleSymbolChange = (e) => {
        store.dispatch(symbolFilter({ key: e.target.value }))
        setSymbolKeyLength(!symbolKeyLength)
    }

    const handleDeleteOptionsSymbol = (item, index) => {
        store.dispatch(deleteOptionSymbol({ payload: item, index: index }))
    }

    return (
        <div style={{ width: "92%", margin: "0 auto", marginTop: 30 }}>
            <form style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}} onSubmit={handleAddNew} >     

                <FormControl required variant="" style={{ marginRight: 15, width: 470 }} size='small' >
                    <InputLabel required id="plan" style={{ color: color }} >
                        Symbol type
                    </InputLabel>
                    <Select
                        style={{ color: color }}
                        labelId="stockType"
                        id="stockType"
                        name="stockType"
                        label="Symbol type"
                    >
                        <MenuItem value={"eq"}> Equity </MenuItem>
                        <MenuItem value={"fut"}> Futures </MenuItem>
                    </Select>
                </FormControl>

                {darkMode ? 
                    <CssTextField
                        style={{width: "100%", margin: "20px 0px"}}
                        required
                        variant="outlined"
                        name="symbol"
                        id="symbol"
                        label="Search symbol" 
                        size="small"
                        onChange={handleSymbolChange}
                    /> : 
                    <TextField
                        style={{width: "100%", margin: "20px 0px"}}
                        required
                        variant="outlined"
                        name="symbol"
                        id="symbol"
                        label="Search symbol" 
                        size="small"
                        onChange={handleSymbolChange}
                    />
                }
                <button style={{ display: "flex", width: 120, justifyContent: "center", border: "1px solid rgba(0,0,0,0.24)", padding: 10, marginLeft: 10, borderRadius: 4, cursor: "pointer" }} type="submit" >
                    Add new
                </button>
            </form>

            <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }} >
                {symbols.map((item, index) => 
                    item.ty === "op" ? 
                        <Chip style={{ marginRight: 5, marginTop: 5, marginBottom: 5, color: color, borderColor: color }} variant="outlined" label={item.sym + " "+types[item.ty]} onDelete={()=> handleDeleteOptionsSymbol(item, index)} deleteIcon={<DeleteIcon style={{ color: darkMode && 'white' }} />}  /> :
                        <Chip style={{ marginRight: 5, marginTop: 5, marginBottom: 5, color: color, borderColor: color }} variant="outlined" label={item.sym + " "+types[item.ty]}  />
                )}
            </div>
        </div>
    )
}

export default AddNewSymbol